import React, { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import EventCard from "../Components/EventCard";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../../shared/utilitiies";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../../../redux/actions";

const UpcomingEventsList = ({ events, getMoreEvents, totalEvents, setSelectedEvent }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cities = useSelector((state) => state.LoginReducer.cities);

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [dispatch]);
  return (
    <>
      <InfiniteScroll
        dataLength={events?.length ?? 0}
        next={getMoreEvents}
        hasMore={
          events?.length % 7 === 0 && events?.length !== 0 && totalEvents !== 7 ? true : false
        }
        loader={loadingIndicator(t)}
        endMessage={dataEndMessage(t , events)}
        style={{ overflow: "hidden" }}
        scrollableTarget={"main-container"}
      >
        <div className="row m-0 w-100">
          {events?.map((event) => {
            const city = cities?.find((s) => s.id === event?.cityId);
            return (
              <EventCard
                key={event.id}
                event={event}
                city={city}
                setSelectedEvent={setSelectedEvent}
                isUpcomingTab={true}
              />
            );
          })}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default UpcomingEventsList;
